/**
 * Configuration runtime du client.
 *
 * Tout vient de variables VITE_*, remplacees statiquement au build. Le meme
 * code tourne donc en localhost et en prod sans modification : seul le fichier
 * .env change (cf. .env.example).
 */
import { SHARE_URL as SHARE_URL_FALLBACK } from '@retusch/shared';

/**
 * URL publique du jeu. Sert a l'image de partage et aux intents sociaux ; elle
 * n'a rien a voir avec l'origine servie (le jeu peut tourner en preview locale
 * tout en pointant le domaine de prod).
 */
export const SHARE_URL: string =
  import.meta.env?.VITE_SHARE_URL ?? SHARE_URL_FALLBACK;

/**
 * Origine WebSocket. Voir net/connection.ts pour la resolution complete : sans
 * VITE_WS_URL, elle est deduite de window.location, ce qui couvre le dev comme
 * un deploiement ou le jeu et le serveur partagent le domaine.
 */
export const WS_URL: string | undefined = import.meta.env?.VITE_WS_URL;
